module.exports={
  "fields": {
    "license": {
      "title": "Lisens (for opplasta kart)",
      "values": ["Verna av opphavsrett [ingen lisens]", "Eigd av alle - ikkje verna av opphavsrett", "Fråskriving av opphavsrett (CC0)", "Namngjeving (CC BY 4.0)"]
    }
  }
}
